import {
  ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__REQUEST,
  ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__SUCCESS,
  ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__REQUEST:
    case ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__SUCCESS:
      return null;

    case ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
